import { Action, createReducer, on } from "@ngrx/store";
import { ColumnSorterInfo } from "src/app/models/custom-table/custom-table.model";
import * as MovementsActionTypes from "../../actions/movements/movements.actions";

export interface MovementsState {
  movementsList: any[];
  movement: any;
  isLoading: boolean;
  movementExcelList: any;
  totalMovements: number;
  movementTableConfig: ColumnSorterInfo[];
}

export const initialState: MovementsState = {
  movementsList: null,
  movement: null,
  isLoading: false,
  totalMovements: null,
  movementExcelList: null,
  movementTableConfig: null,
};

const movementsReducer = createReducer(
  initialState,
  on(MovementsActionTypes.resetMovementsState, () => initialState),
  on(MovementsActionTypes.getContractMovementsList, (state, { options }) => ({
    ...state,
    options,
    isLoading: true,
  })),
  on(
    MovementsActionTypes.loadContractMovementsPartyList,
    (state, { response }) => ({
      ...state,
      movementsList: (response as any)?.result?.items || undefined,
      error: null,
      isLoading: false,
      totalMovements: (response as any)?.result?.size
        ? (response as any)?.result?.size
        : 0,
    })
  ),
  on(MovementsActionTypes.loadMovementsLoadStart, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(MovementsActionTypes.loadMovementsLoadEnd, (state) => ({
    ...state,
    isLoading: false,
    error: null,
  })),
  on(
    MovementsActionTypes.getMovement,
    (state, { options }) =>
      ({
        ...state,
        error: null,
        action: options,
        movement: undefined,
        isLoading: true,
      } as MovementsState)
  ),
  on(MovementsActionTypes.loadMovement, (state, { response }) => {
    return {
      ...state,
      movement: (response as any)?.items?.[0]
        ? (response as any)?.items?.[0]
        : undefined,
      isLoading: false,
      error: null,
    };
  }),
  on(MovementsActionTypes.resetMovement, (state) => {
    return {
      ...state,
      movement: null,
      error: null,
    };
  }),
  on(
    MovementsActionTypes.getMovementsExcelList,
    (state, { options }) =>
      ({
        ...state,
        error: null,
        options: options,
        isLoading: true,
      } as MovementsState)
  ),
  on(MovementsActionTypes.loadMovementsExcelList, (state, { response }) => {
    return {
      ...state,
      movementExcelList: (response as any)?.result?.items
        ? (response as any)?.result?.items
        : undefined,
      isLoading: false,
      error: null,
    };
  }),
  on(MovementsActionTypes.getMovementTableConfig, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(MovementsActionTypes.loadMovementTableConfig, (state, { response }) => {
    return {
      ...state,
      movementTableConfig:
        (response as any)?.result?.value?.tableColumnInfo ?? undefined,
    };
  }),
  on(MovementsActionTypes.saveMovementTableConfig, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(MovementsActionTypes.setLoadingEndState, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  })
);

export function reducer(state: MovementsState | undefined, action: Action) {
  return movementsReducer(state, action);
}
